import {
	AccordionComponent,
	CheckboxComponent,
	ContentBlockComponent,
	Heading,
	IconComponent,
	LinkComponent,
	PageBlockComponent,
	themeColor,
	themeFontWeight,
} from 'LibNeo'
import styled, { createGlobalStyle, css } from 'styled-components'
import { Menu } from 'antd'
import { Filters } from 'Modules'
import { Status } from 'LibNeo/components/Basic/Status/styled'
import { UpBtnStyle } from 'LibNeo/components/Basic/Buttons/UpButton/styled'
import { CheckboxWrapper } from 'LibNeo/components/Basic/Checkbox/styled'
import { LinkProps } from 'LibNeo/components/Basic/Link/styled'
import { BlockButtons, Button, WrapperIcon } from 'LibNeo/components/Basic/Buttons/Button/styled'
import { WrapperContainer } from 'LibNeo/components/Basic/Input/common/styled'

export const DelimeterWrapperStyled = styled.div`
	padding-top: 3px;
	padding-bottom: 4px;
`

export const DelimiterStyled = styled.div`
	height: 1px;
	background-color: ${themeColor('gray', 3)};
`

export const LinkComponentCustomStyled = styled(LinkComponent)<LinkProps>`
	pointer-events: initial;

	${({ disable }) =>
		disable &&
		css`
			color: ${themeColor('emerald', 3)};
			cursor: default;

			&:hover,
			&:active {
				color: ${themeColor('emerald', 3)};
			}
		`}
`

export const AttributeWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	line-height: 19px;
`

export const RightText = styled.div`
	text-align: right;
	${Status} {
		vertical-align: bottom;
	}
`

export const PageWrapper = styled.div<{ isShowFilters: boolean }>`
	display: flex;
	margin-top: 16px;
	flex: 1 1 auto;
	overflow: hidden;
	gap: 24px;
	${Filters} {
		align-self: baseline;
		max-width: 30vw;
		flex: ${({ isShowFilters }) => (isShowFilters ? '0 1 520px' : '1 1 0')};
		transition: 0.3s;
	}
`

export const ContentWrapper = styled.div<{ isShowFilters: boolean }>`
	display: flex;
	flex-direction: column;
	flex: 1 2 auto;
	max-height: 100%;
	min-width: ${({ isShowFilters }) => (isShowFilters ? '40%' : '100%')};
	transition: 0.3s;
`

export const FlexWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
`

export const HiddenStyled = styled.div<{ isHide?: boolean }>`
	${({ isHide = true }) =>
		isHide &&
		css`
			height: 0;
			visibility: hidden;
			width: 0;
		`}
`

export const SmallCheckbox = styled(CheckboxComponent)`
	&${CheckboxWrapper} {
		min-height: auto;
		& + ${CheckboxWrapper} {
			margin-top: 16px;
		}
	}
`

export const GrayCaption = styled.div<{ $color?: number }>`
	font-size: 12px;
	line-height: 20px;
	color: ${({ $color = 6 }) => themeColor('gray', $color)};
`

export const WhiteBlock = styled(ContentBlockComponent)<{ $maxWidth?: number; success?: boolean }>`
	padding: 40px;
	box-shadow: none;
	margin: 0 auto;

	${({ $maxWidth }) =>
		$maxWidth &&
		css`
			max-width: ${$maxWidth}px;
		`}
	${Button} {
		&:not(:nth-of-type(1)) {
			margin-left: 16px;
		}
	}

	${({ success }) =>
		success &&
		css`
			border-color: ${themeColor('emerald', 5)};
		`}
`

export const DropdownListStyled = styled(Menu)`
	max-width: 280px;
	background-color: ${themeColor('gray', 9)};
	border-radius: 0 0 6px 6px;
	padding: 6px 0;
	.ant-dropdown-menu-item {
		white-space: normal;
	}
`

export const HidingBlock = styled.div<{ isHide?: boolean }>`
	display: ${({ isHide }) => (isHide ? 'none !important' : 'block')};
`

export const InnIcon = styled(IconComponent)`
	position: absolute;
	right: 12px;
	top: 33px;
`

export const InnWithIcon = styled.div`
	position: relative;
	${WrapperContainer} {
		.ant-input {
			padding-right: 40px;
		}
	}
`

export const GridStyle = createGlobalStyle`
		.ppneo-scrollable-grid.ppneo-scrollable-grid {
			border-radius: 0;
			padding: 0;
			border: none;
			overflow: hidden;
			height: auto;
			.ppneo-grid-header-container {
				border-bottom: 1px solid ${themeColor('gray', 3)};
				overflow-y: hidden;
				.ppneo-grid-header__item:nth-child(3) {
					text-align: right;
				}
			}
			.ppneo-grid-header {
				color: ${themeColor('extraBackground3')};
				font-weight: 500;
			}
			.ppneo-grid-content {
				font-size: 12px;
				line-height: 16px;
				color: ${themeColor('gray', 6)};
				.ppneo-grid-row {
					margin: 0;
					&__item:nth-child(3) {
						text-align: right;
					}
				}
			}
		}
`

export const ListGridStyle = createGlobalStyle`
	${ContentWrapper} {
		.ppneo-scrollable-grid {
			border-radius: 0;
			padding: 0;
			overflow: hidden;
		}

		.ppneo-grid-content {
			color: ${themeColor('gray', 8)}
		}

		.ppneo-grid-row__list {
			align-items: flex-start;
		}

		.ppneo-grid__table-label {
			display: none;
		}

		.ppneo-grid-header-container {
			min-height: 40px;
		}

		.ppneo-grid-header {
			line-height: 20px;
			font-weight: 400;
			color: ${themeColor('gray', 5)};

			&__item {
				display: block;
				margin-left: 20px;
				padding: 10px 0;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;

				&:nth-child(4),
				&:nth-child(5),
				&:nth-child(7),
				&:nth-child(8) {
					text-align: right;
				}
			}
		}

		.ppneo-grid-header-row {
			display: block;
			padding: 0;
			border-bottom: 1px solid ${themeColor('gray', 3)}
		}

		.ppneo-grid-row {
			margin: 0;
			padding: 20px 0;

			&__item {
				margin-left: 20px;
			}
		}

		${UpBtnStyle} {
			font-size: 0;
			border-radius: 50%;
			box-shadow: 0 4px 16px -2px rgba(0, 0, 0, 0.15);
			background-color: ${themeColor('arctic', 5)};
			border: 2px solid ${themeColor('arctic', 5)};
			padding: 6px;

			${WrapperIcon} {
				width: 24px;
				height: 24px;
				margin-left: 0;

				svg {
					width: 24px;
					height: 24px;
					fill: ${themeColor('gray', 8)};
				}
			}
		}
	}
`

export const PageContainer = styled.div`
	display: flex;
	gap: 20px;
	overflow: auto;
	& > div:first-child {
		flex: 1 1 auto;
		& > div + div {
			margin-top: 20px;
		}
	}
	& > div:last-child {
		position: sticky;
		top: 0;
		flex-shrink: 0;
		align-self: flex-start;
		overflow: auto;
		scrollbar-width: none;
		&::-webkit-scrollbar {
			display: none;
		}
	}
`

export const GovPagesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`

export const GrayText = styled.div<{ $color?: number; $fontSize?: number }>`
	font-size: ${({ $fontSize = 14 }) => `${String($fontSize)}px`};
	line-height: 24px;
	color: ${({ $color = 6 }) => themeColor('gray', $color)};
`

export const GrayIcon = styled(IconComponent)`
	svg {
		fill: ${themeColor('gray', 8)};
	}
`

export const MainText = styled.div`
	font-weight: ${themeFontWeight('SBSansText', 'semibold')};
	font-size: 20px;
	line-height: 32px;
	color: ${themeColor('extraBackground3')};
`

export const UnderMainText = styled.span`
	font-weight: ${themeFontWeight('SBSansText', 'regular')};
	font-size: 12px;
	line-height: 20px;
	color: ${themeColor('gray', 8)};
	margin-bottom: 18px;
`

export const BoldText = styled.span`
	font-weight: ${themeFontWeight('SBSansText', 'semibold')};
	color: ${themeColor('extraBackground3')};
	font-size: 16px;
	line-height: 20px;
	margin-bottom: 4px;
	margin-right: 9px;
`

export const LightText = styled.span`
	font-weight: ${themeFontWeight('SBSansText', 'regular')};
	color: ${themeColor('gray', 5)};
	font-size: 12px;
	line-height: 20px;
`
export const Link = styled.a`
	text-decoration: underline dotted ${themeColor('emerald', 5)};
	color: ${themeColor('emerald', 5)};
`

export const ModalWrapper = styled.div`
	padding-left: 8px;
	padding-right: 8px;
`

export const QRCode = styled.img`
	width: 160px;
	height: 160px;
`

export const ModalContent = styled(PageBlockComponent)`
	padding-bottom: 2px;
`

export const TrekNumberText = styled.span`
	font-size: 14px;
	line-height: 20px;
	color: ${themeColor('gray', 5)};
	font-style: italic;
`

export const TotalWrapper = styled.div`
	display: flex;
	margin: 40px 0;
	& > h5:first-child {
		flex-shrink: 0;
		width: 240px;
	}
`

export const AccordionComponentStyled = styled(AccordionComponent)`
	.ant-collapse-item.ant-collapse-no-arrow .ant-collapse-content.ant-collapse-content-inactive {
		display: block;
		height: 0;
		visibility: hidden;
		overflow: hidden;
	}
`

export const AsideIconsWrapper = styled.div`
	display: flex;
	align-items: center;
`

export const LoaderHeadingStyled = styled(Heading)`
	font-weight: 400;
	display: inline-block;
`
export const BlockButtonsStyled = styled(BlockButtons)`
	padding-top: 24px;
`
